import * as React from "react";
import * as ReactDOM from "react-dom";
//Import Components
import Main from "./components/views/Main";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

const root = document.querySelector(".container");

ReactDOM.render(
    <Main />,    
    root
);




// WEBPACK FOOTER //
// ./src/index.tsx